import { HStack as ChakraHStack } from '@chakra-ui/react';
import { ElementType } from 'react';
import { StackProps } from './stack.types';

export function HStack<T extends ElementType = 'div'>(props: StackProps<T>) {
  return <ChakraHStack {...props} />;
}